// extracted by mini-css-extract-plugin
export var container = "_8n-0";
export var error = "_8n-9";
export var label = "_8n-5";
export var light = "_8n-6";
export var md = "_8n-3";
export var sm = "_8n-2";
export var thin = "_8n-8";
export var thinBold = "_8n-7";
export var vertical = "_8n-4";
export var xs = "_8n-1";